var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.valueIsDefined)?_c('div',[(_vm.selectAll)?_c('span',[_vm._v(_vm._s(_vm.selectAll))]):_c('sample-shelf-badge',{attrs:{"status":_vm.params.value}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }